<template>
  <div class="bto-sb-event-mormarket-market bto-sb-event-mormarket-swish">
    <div class="bto-sb-event-mormarket-market-name">
      <h4>{{ marketName }}</h4>
    </div>
    <div
      class="bto-sb-event-mormarket-market-odd"
      v-for="(item, idx) in oddsToBeDisplayed"
      :key="idx">
      <template v-if="item.fullName">
        <span>
          {{ item.fullName }}
        </span>
        <span>
          <a
            :class="[
              'bto-sb-event-odd',
              { 'bto-sb-event-mormarket-market-odd-active': isItSelected(item.overLongId) },
            ]"
            @click="addOdd(item, item.overOdd, item.overLongId, line.OVER)">
            <i>{{ t("Outcome.Over").toUpperCase() }} {{ item.line }}</i>
          </a>
          <a
            :class="[
              'bto-sb-event-odd',
              { 'bto-sb-event-mormarket-market-odd-active': isItSelected(item.underLongId) },
            ]"
            @click="addOdd(item, item.underOdd, item.underLongId, line.UNDER)">
            <i>{{ t("Outcome.Under").toUpperCase() }} {{ item.line }}</i>
          </a>
        </span>
      </template>
      <template v-else>
        <span>
          <a
            :class="[
              'bto-sb-event-odd',
              { 'bto-sb-event-mormarket-market-odd-active': isOverSelected(item) },
            ]"
            @click="addOverOdd(item)">
            <i>
              {{ item.showTeamName ? match.homeTeam : t("Outcome.Over") }}
              {{ getLineName(item) }}
            </i>
          </a>
        </span>
        <span v-if="item.awaySpread">
          <a
            :class="[
              'bto-sb-event-odd',
              { 'bto-sb-event-mormarket-market-odd-active': isItSelected(item.awaySpread.underLongId) },
            ]"
            @click="addOdd(item.awaySpread, item.awaySpread.underOdd, item.awaySpread.underLongId, line.UNDER)">
            <i>
              {{ match.guestTeam }}
              {{ getLineName(item.awaySpread) }}
            </i>
          </a>
        </span>
        <span v-else>
          <a
            :class="[
              'bto-sb-event-odd',
              { 'bto-sb-event-mormarket-market-odd-active': isItSelected(item.underLongId) },
            ]"
            @click="addOdd(item, item.underOdd, item.underLongId, line.UNDER)">
            <i>
              {{ item.showTeamName ? match.guestTeam : t("Outcome.Under") }}
              {{ getLineName(item) }}
            </i>
          </a>
        </span>
      </template>
    </div>
    <div v-if="showMoreOddsBtn()" class="bto-sb-widget-footer">
      <a
        @click.prevent="showMoreOrLessOdds()"
        class="bto-sb-more-item bto-sb-show"
        v-if="showMoreOddsBtn() && !showMoreOdds[`${fixture.matchId}-${marketName}`]">
        {{ t("Mobile.ShowMore") }}
      </a>
      <a
        v-if="showMoreOdds[`${fixture.matchId}-${marketName}`]"
        @click.prevent="showMoreOrLessOdds()"
        class="bto-sb-more-item bto-sb-less">
        {{ t("Mobile.ShowLess") }}
      </a>
    </div>
  </div>
</template>

<script>
  import store from "../../../../../store";
  import { betslipStore, toggleSwishBetBuilder, configStore, getItemHashKey } from "@bto-services/betslip-core";
  import { SWISH_ODDS_LINE } from 'bto-models/betslip';
  import { getLineName } from 'bto-models/match/details/betbuilder/mapper.js';

  export default {
    name: "SwishBetBuilderMarket",
    data() {
      return {
        line: SWISH_ODDS_LINE,
      }
    },
    props: {
      marketName: {
        type: String,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
      fixture: {
        type: Object,
        required: true,
      },
      matchInfo: {
        type: Object,
        required: true,
      },
      match: {
        type: Object,
        default: () => ({}),
      },
    },
    methods: {
      showMoreOrLessOdds() {
        // Toggle odds display
        store.commit("toggleOddsDisplay", `${this.fixture.matchId}-${this.marketName}`);
      },
      showMoreOddsBtn() {
        const visibleOdds = +APP_SETTINGS.settings.outcomesToShowByDefault;
        return (this.items.length || 0) > visibleOdds;
      },
      isOverSelected(market) {
        if (market.showLine && market.showTeamName) {
          return this.isItSelected(market.underLongId);
        }
        return this.isItSelected(market.overLongId);
      },
      addOverOdd(market) {
        // If spread market add under odd
        if (market.showLine && market.showTeamName) {
          this.addOdd(market, market.underOdd, market.underLongId, this.line.UNDER, true);
          return;
        }
        this.addOdd(market, market.overOdd, market.overLongId, this.line.OVER);
      },
      addOdd(market, odd, longId, line, isHomeSpread = false) {
        // we check if description is related to a team or a specific player
        const teamName = line === SWISH_ODDS_LINE.OVER || isHomeSpread ? this.match.homeTeam : this.match.guestTeam;
        const ouText = market.fullName || !market.showTeamName ? this.$translate.text(`Outcome.${line}`) : '';
        const playerOrTeam = market.fullName || (market.showTeamName ? teamName : '');

        const descLine = (market.fullName || market.showLine) ? `${ouText} ${getLineName(market)}` : '';
        const bbMarket = {
          description: `${playerOrTeam} ${descLine}`,
          globalId: longId,
          name: this.marketName,
          isComplex: false,
          line: market.line,
          statsId: market.statsId,
          odd,
        };

        // we add this properties if it's player props market
        if (market.matchPlayerId) {
          bbMarket.matchPlayerId = market.matchPlayerId;
          bbMarket.playerId = market.playerId;
        }

        // we add this properties if it's pre-match market
        if (market.preMatchMarketId) {
          bbMarket.preMatchMarketId = market.preMatchMarketId;
          bbMarket.team = market.team;
        }
        const newFixture = {
          ...this.fixture,
          swMatchId: this.matchInfo.matchID,
          swSwishMatchID: this.matchInfo.swishMatchID,
          swTournamentName: this.matchInfo.tournamentName,
          swHomeTeamID: this.matchInfo.homeTeamID,
          swAwayTeamID: this.matchInfo.awayTeamID,
        }
        toggleSwishBetBuilder(newFixture, bbMarket);
      },
      isItSelected(longId) {
        const marketId = configStore.settings.BET_BUILDER_SWISH_MARKET_ID;
        const outcomeId = configStore.settings.BET_BUILDER_SWISH_OUTCOME_ID;
        const betItemKey = { marketId, outcomeId, matchId: this.fixture.matchId };
        const itemKey = getItemHashKey(betItemKey);
        if (betslipStore.items[itemKey]) {
          return !!betslipStore.items[itemKey].betBuilder[longId];
        }
        return false;
      },
      getLineName,
    },
    computed: {
      showMoreOdds() {
        return store.state.GlobalModule.showMoreOdds;
      },
      oddsToBeDisplayed() {
        const visibleOdds = +APP_SETTINGS.settings.outcomesToShowByDefault;
        return this.showMoreOdds[`${this.fixture.matchId}-${this.marketName}`]
          ? this.items
          : this.items.slice(0, visibleOdds);
      },
    },
  };
</script>